import Reveal from '../../../shared/Reveal/Reveal';
import { usePlatformsDidContent } from '../../../../hooks/usePlatformsDidContent';
import monitorIcon from '../../../../assets/images/platforms/did/Monitor.svg';
import globeIcon from '../../../../assets/images/platforms/did/Globe.svg';
import mobileIcon from '../../../../assets/images/platforms/did/DeviceMobile.svg';
import './DID.css';

const fallbackIcons = [monitorIcon, globeIcon, mobileIcon];

const DID = () => {
  const { content, isLoading } = usePlatformsDidContent();

  if (isLoading || !content) {
    return null;
  }

  const { items } = content;

  return (
    <section className="platforms-did">
      <div className="platforms-did__inner">
        <div className="platforms-did__grid">
          {items.map(({ title, text, icon }, index) => (
            <Reveal key={title} delay={index * 80}>
              <article className="platforms-did__item">
                <img
                  className="platforms-did__icon"
                  src={icon || fallbackIcons[index]}
                  alt=""
                  aria-hidden="true"
                />
                <h3 className="platforms-did__title">{title}</h3>
                <p className="platforms-did__text">{text}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DID;
